//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import PortalFileUpload from "@/pcpage/hr/recruitment/portal/component/PortalFileUpload";
import portalFileList from "@/pcpage/hr/recruitment/portal/component/portalFileList";
import redBorderDialog from "./redBorderDialog.vue";
export default {
  name: "resume",
  components: {
    PortalFileUpload,
    portalFileList,
    redBorderDialog,
  },
  props: {
    showResume: {
      type: Boolean,
      default: true,
    },
    record: {
      type: Object,
      default: () => ({}),
    },
    rules: {
      type: Object,
      default: () => ({}),
    },
    readonly: {
      type: Boolean,
      default: false,
    },
    resumeType: {
      //简历方式
      type: String,
      default: "",
    },
    restaurants: {
      //简历方式
      type: Array,
      default: () => [],
    },
    addrecord: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      degreeList: [],
      educationStatusList: [],
      experienceStatusList: [],
      yesOrNoList: [],
      redBorderDialogBool: false,
      filePortalForm: {
        docutypeid: "portal",
        keyval: "",
        btype: "PORTALUSER",
      },
      temp: "",
      getFileListUrl: "api/api/portalFile/getFileInfos",
    };
  },
  watch: {
    record: {
      handler(newValue) {
        console.log("resume", newValue);
        if (newValue.educationlist.length == 0) {
          this.record.educationlist = [{}];
        }
        if (newValue.experiencelist.length == 0) {
          this.record.experiencelist = [{}];
        }
      },
      immediate: true,
      deep: true,
    },
  },
  methods: {
    openAttachmentHistory() {
      this.redBorderDialogBool = true;
      this.$nextTick(() => {
        this.$refs.RedBorderDialog.init("AttachmentHistory", this.record);
      });
    },
    querySearch(queryString, callBackVal) {
      var restaurants = this.restaurants;
      var results = queryString
        ? restaurants.filter(this.createFilter(queryString))
        : restaurants;
      //调用 callback 返回建议列表的数据
      callBackVal(results);
    },
    resetRem() {
      let html = document.documentElement;
      html.style.fontSize = 100 * (html.clientWidth / 750) + "px";
      // 监听 window 的 resize 事件．在浏览器窗口变化时再设置下区域高度．
      window.onresize = () => {
        let html = document.documentElement;
        html.style.fontSize = 100 * (html.clientWidth / 750) + "px";
      };
    },
    createFilter(queryString) {
      return (restaurant) => {
        return (
          restaurant.value.toLowerCase().indexOf(queryString.toLowerCase()) ===
          0
        );
      };
    },

    // handleSelect() {
      // record.resumename
      // this.loadResumeInfo(this.record.resumename[0].resumeid);
      // this.loadResumeInfo(item);
    // },
    setCurrentlyenrolled(obj) {
      //设置值
      let ifcurrentlyenrolled = "0";
      if (obj.enrolled) {
        ifcurrentlyenrolled = "1";
      }
      obj.ifcurrentlyenrolled = ifcurrentlyenrolled;
    },
    fileUploadBack() {
      //文件上传回调
      this.getFileList("portalfilelist", "bportaluser", "portal");
    },
    initSelect() {
      //初始化行项下拉框对应值
      let params = [];
      //初始化下拉框
      let stockArray = {
        showcode: "degreeList",
        selectcode: "SYS_CDFCODECONFIG",
        hasnull: true,
        paras: {
          paras0: "EDUCATIONLEVEL",
          paras1: "1",
        },
      };
      let educationStatus = {
        showcode: "educationStatusList",
        selectcode: "SYS_CDFCODECONFIG",
        hasnull: true,
        paras: {
          paras0: "PORTAL_EDUCATION_STATUS",
          paras1: "1",
        },
      };
      let experienceStatus = {
        showcode: "experienceStatusList",
        selectcode: "SYS_CDFCODECONFIG",
        hasnull: true,
        paras: {
          paras0: "RECRUIT_EXPERIENCE",
          paras1: "1",
        },
      };
      let yesOrNo = {
        showcode: "yesOrNoList",
        selectcode: "SYS_CDFCODECONFIG",
        hasnull: true,
        paras: {
          paras0: "YESORNO",
          paras1: "1",
        },
      };
      params.push(stockArray);
      params.push(educationStatus);
      params.push(experienceStatus);
      params.push(yesOrNo);
      this.initDropDown(this, params);
    },
    async getFileList(objList, tagName, docuTypeId) {
      //获取附件列表
      let email = this.record.email;
      let resumeid = this.record.resumeid;
      if (!this.isNotNullOrEmpty(email)) {
        email = "";
      }
      if (!this.isNotNullOrEmpty(resumeid)) {
        resumeid = "";
      }
      let url = this.getFileListUrl;
      let params = {
        record: {
          keyval: resumeid,
          accountid: email,
          tagname: tagName,
          docutypeid: docuTypeId,
          limit: "1",
        },
      };
      await this.axios
        .post(url, params)
        .then(({ data }) => {
          if ("1" === data.code) {
            let fileList = data.data.record.filelist;
            this.$set(this.record, objList, fileList);
          }
        })
        .catch((error) => console.log(error));
    },
    focusDatePicker() {
      console.log(
        "el-picker-panel",
        document.getElementsByClassName("el-picker-panel")
      );
    },
    async loadResumeInfo(resumeid) {
      //加载简历信息
      let emailUrl = "api/api/portalLogin/getPortalResumeInfo";
      let params = {
        record: {
          resumeid: resumeid,
        },
      };
      await this.axios
        .post(emailUrl, params)
        .then(({ data }) => {
          if (data.code == "1") {
            let json = data.data.record;
            // for (let key in json) {
              //this.record = data.data.record;
              //this.record[key]=json[key];
              // this.$set(this.record, key, json[key]);
            // }
            // this.record["act"] = "";
          }
        })
        .catch((error) => console.log(error));
    },

    educationStatusChange(index, value) {
      if (value == '03') {
        this.$set(this.record.educationlist[index], 'degree', '');
        this.$set(this.record.educationlist[index], 'schoolname', '');
        this.$set(this.record.educationlist[index], 'honors', '');
        this.$set(this.record.educationlist[index], 'begindate', '');
        this.$set(this.record.educationlist[index], 'enddate', '');
      }
    },

    experienceStatusChange(index, value) {
      if (value == '0') {
        this.$set(this.record.experiencelist[index], 'begindate', '');
        this.$set(this.record.experiencelist[index], 'enddate', '');
        this.$set(this.record.experiencelist[index], 'company', '');
        this.$set(this.record.experiencelist[index], 'position', '');
        this.$set(this.record.experiencelist[index], 'leavereason', '');
        this.$set(this.record.experiencelist[index], 'description', '');
      }
      if (value == '2') {
        this.$set(this.record.experiencelist[index], 'enddate', '');
      }
    }
  },
  created() {
    this.initSelect();
  },
};



// WEBPACK FOOTER //
// ./src/pcpage/hr/recruitment/portal/component/resume.vue